import "./TheGear.module.css";
import Header from "@/reusable_sections/Header";
import TheFullBackline from "./sections/TheFullBackline";
import ReadyToPlugIn from "./sections/ReadyToPlugIn";
import Footer from "@/reusable_sections/Footer";
export default function TheGearPage() {
  return <div>
      <Header />
      <TheFullBackline />
      <ReadyToPlugIn />
      <Footer />
    </div>;
}